import { type Commands } from '../commands';
import { UUID } from '../uuid/entity';
import { Tactic } from './entity';
import { type TacticData } from './dto';
import { Tactics } from './repository';

export class TacticsCommands implements Commands<Tactics, Tactic, TacticData> {
    addAll(repo: Tactics, data: TacticData[]): Tactics {
        repo.clear();
        data.forEach((tacticData) => {
            this.add(repo, tacticData);
        });
        return repo;
    }

    add(repo: Tactics, data: TacticData): Tactics {
        const tactic = new Tactic({
            id: data.id,
            name: data.name,
            label: data.label,
            description: data.description,
            srcId: data.srcId,
            url: data.url,
            techniqueIds: data.techniques.map(({ id }) => id),
        });
        repo.add(tactic);
        return repo;
    }

    update(repo: Tactics, entity: Tactic): Tactic {
        repo.update(entity);
        return entity;
    }

    remove(repo: Tactics, id: string): void {
        repo.remove(id);
    }

    create(repo: Tactics, data: Omit<TacticData, 'id'>): Tactic {
        const uuid = new UUID();
        const tactic = new Tactic({
            id: uuid.toString(),
            name: data.name,
            label: data.label,
            description: data.description,
            srcId: data.srcId,
            url: data.url,
            techniqueIds: data.techniques.map(({ id }) => id),
            isCustom: true,
        });
        repo.add(tactic);
        return tactic;
    }

    fromJSON(entity: Tactic[], changeCallback: () => void): Tactics {
        const newTactics = new Tactics(changeCallback);
        entity.forEach((tactic) => {
            newTactics.add(
                new Tactic({
                    id: tactic.id,
                    name: tactic.name,
                    label: tactic.label,
                    description: tactic.description,
                    srcId: tactic.srcId,
                    url: tactic.url,
                    techniqueIds: tactic.techniqueIds,
                    isCustom: tactic.isCustom,
                }),
            );
        });
        return newTactics;
    }
}
